"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CellCalculationController = (function () {
    function CellCalculationController() {
    }
    CellCalculationController.doCalculation = function (oldValue, newValue, columnInfo) {
        if (typeof newValue !== "string") {
            newValue = newValue.toString();
        }
        newValue = newValue.replace(" ", "");
        var sign = newValue[0];
        if (sign === "+" || sign === "-" || sign === "*" || sign === "/") {
            newValue = newValue.substr(1);
        }
        var percent = newValue[newValue.length - 1];
        if (percent === "%") {
            newValue = newValue.substr(0, newValue.length - 1);
        }
        else {
            percent = undefined;
        }
        var theNumber = parseFloat(newValue);
        var result = oldValue;
        var percentage = 100;
        if (percent) {
            theNumber = theNumber / percentage;
            switch (sign) {
                case "+":
                    result *= (1 + theNumber);
                    break;
                case "-":
                    result *= (1 - theNumber);
                    break;
                case "*":
                    result /= theNumber;
                    break;
                case "/":
                    if (theNumber !== 0) {
                        result *= theNumber;
                    }
                    else {
                        result = 0;
                    }
                    break;
                default: result = theNumber;
            }
        }
        else {
            switch (sign) {
                case "+":
                    result += theNumber;
                    break;
                case "-":
                    result -= theNumber;
                    break;
                case "*":
                    result *= theNumber;
                    break;
                case "/":
                    if (theNumber !== 0) {
                        result /= theNumber;
                    }
                    else {
                        result = 0;
                    }
                    break;
                default:
                    result = theNumber;
            }
        }
        return CellCalculationController.validateValue(result, columnInfo);
    };
    CellCalculationController.validateValue = function (value, columnInfo) {
        var theSettings = columnInfo.settings;
        if (theSettings) {
            var minVal = theSettings.minValue;
            var maxVal = theSettings.maxValue;
            if (theSettings.factor) {
                minVal /= theSettings.factor;
                maxVal /= theSettings.factor;
            }
            if (value < minVal) {
                value = minVal;
            }
            else if (value > maxVal) {
                value = maxVal;
            }
        }
        return value;
    };
    CellCalculationController.isCalculation = function (value) {
        if (!value) {
            return false;
        }
        var valueString = value.toString().trim();
        var firstChar = valueString[0];
        var operators = ["+", "-", "*", "/"];
        return (operators.indexOf(firstChar) > -1);
    };
    return CellCalculationController;
}());
exports.CellCalculationController = CellCalculationController;
//# sourceMappingURL=cellCalculationController.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/datalayer/cellCalculationController.js
// module id = 45
// module chunks = 0